
import { computed, ComputedRef } from 'vue';

import { SupportedPaymentMethodDetails, MbwayDto, PaypalDto, CardDto, FuelCardDto, PaymentMethodDto } from '../views/PartnerWallet/apiPartner/types';

export const PAYMENT_METHODS_NAMES_MAP = {
  DIRECT_CREDIT: 'history.payments.credit_card',
  GOOGLE_PAY: 'history.payments.google',
  APPLE_PAY: 'history.payments.apple',
  MBWAY: 'history.payments.mbway',
  PAYPAL: 'history.payments.paypal',
  AMAZON_PAY: 'history.payments.amazon',
  POSTPAY_BY_PARTNER: 'history.payments.POSTPAY_BY_PARTNER',
  POSTPAY_BY_USER: 'history.payments.POSTPAY_BY_PARTNER',
  FUEL_CARD: 'history.payments.fuel_card',
  BLUECODE: 'history.payments.bluecode',
  PAYCONIQ: 'history.payments.payconiq',
};

export const PAYMENT_METHODS_MAP = {
  DIRECT_CREDIT: { svg: 'payments/cards', text: t('payments.payments_names.DIRECT_CREDIT') },
  GOOGLE_PAY: { svg: 'payments/gpay', text: t('payments.payments_names.GOOGLE_PAY') },
  APPLE_PAY: { svg: 'payments/apple-pay', text: t('payments.payments_names.APPLE_PAY') },
  AMAZON_PAY: { svg: 'payments/amazon', text: t('payments.payments_names.AMAZON_PAY') },
  MBWAY: { svg: 'payments/mbway', text: t('payments.payments_names.MBWAY') },
  PAYPAL: { svg: 'payments/paypal', text: t('payments.payments_names.PAYPAL') },
  FUEL_CARD: { svg: 'payments/general-card', text: t('payments.payments_names.FUEL_CARD') },
  POSTPAY_BY_USER: { svg: 'payments/ryd-payment', text: t('payments.payments_names.POSTPAY_BY_USER') },
  POSTPAY_BY_PARTNER: { svg: 'payments/ryd-payment', text: t('payments.payments_names.POSTPAY_BY_PARTNER') },
  BLUECODE: { svg: 'payments/bluecode', text: t('payments.payments_names.BLUECODE') },
  BP_ARAL_ROUTEX: { svg: 'payments/general-card', text: t('payments.payments_names.BP_ARAL_ROUTEX') },
  BP_FUEL_CARD: { svg: 'payments/general-card', text: t('payments.payments_names.BP_ARAL_ROUTEX') },
};
export const PAYMENTS_WALLET = ['GOOGLE_PAY', 'AMAZON_PAY', 'APPLE_PAY'];
export const PAYMENTS_SKIP_VALIDATION = ['GOOGLE_PAY', 'MBWAY', 'DIRECT_CREDIT', 'APPLE_PAY', 'AMAZON_PAY', 'POSTPAY_BY_USER', 'POSTPAY_BY_PARTNER', 'BLUECODE'];
export const PAYMENTS_WITHOUT_DETAILS = ['GOOGLE_PAY', 'AMAZON_PAY', 'APPLE_PAY', 'POSTPAY_BY_USER', 'POSTPAY_BY_PARTNER', 'BLUECODE'];

export function usePaymentInfo(payment: PaymentMethodDto) {
  const providerWithMethod = `${payment.provider}_${payment.providerMethod}`;

  const paymentName = computed(() => {

    const paymentDetailMap = {
      PAYPAL: () => `Paypal ${(payment.paypal as PaypalDto)?.email}`,
      MBWAY: () => {
        const { phoneNumber } = payment.mbway as MbwayDto;
        return `MB WAY +${phoneNumber.replace('#', '')}`;
      },
      GOOGLE_PAY: () => 'Google Pay',
      APPLE_PAY: () => 'Apple Pay',
      AMAZON_PAY: () => 'Amazon Pay',
      BP_FUEL_CARD: () => t('payments.payments_names.BP_ARAL_ROUTEX'),
      DIRECT_CREDIT: () =>
        `${(payment.card as CardDto).brand} ${(payment.card as CardDto).cardNumber}`,
      POSTPAY_BY_USER: () => 'ryd pay',
      POSTPAY_BY_PARTNER: () => 'ryd pay',
      BLUECODE: () => 'Bluecode',
      DEFAULT: () => ''
    };

    const paymentDetailMapHandler = paymentDetailMap[providerWithMethod as keyof typeof paymentDetailMap] ?? paymentDetailMap['DEFAULT'];

    return payment.providerMethod ? paymentDetailMapHandler() : null;
  });

  const paymentDetail = computed(() => {

    const paymentDetailMap = {
      PAYPAL: () => `Paypal ${(payment.paypal as PaypalDto)?.email}`,
      MBWAY: () => {
        const { phoneNumber } = payment.mbway as MbwayDto;
        return `MB WAY +${phoneNumber.replace('#', '')}`;
      },
      GOOGLE_PAY: () => 'Google Pay',
      APPLE_PAY: () => 'Apple Pay',
      AMAZON_PAY: () => 'Amazon Pay',
      BP_FUEL_CARD: () => payment.fuelCard?.cardNumber,
      DIRECT_CREDIT: () =>
        `${(payment.card as CardDto).brand} ${(payment.card as CardDto).cardNumber}`,
      POSTPAY_BY_USER: () => 'ryd pay',
      POSTPAY_BY_PARTNER: () => 'ryd pay',
      BLUECODE: () => 'Bluecode',
      DEFAULT: () => ''
    };

    const paymentDetailMapHandler = paymentDetailMap[providerWithMethod as keyof typeof paymentDetailMap] ?? paymentDetailMap['DEFAULT'];

    return payment.providerMethod ? paymentDetailMapHandler() : null;
  });
  const paymentSimpleInfo = PAYMENT_METHODS_MAP[providerWithMethod as keyof typeof PAYMENT_METHODS_MAP];

  return {
    paymentName,
    paymentDetail: paymentDetail.value,
    paymentSimpleInfo
  };
}